import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Grid} from '@material-ui/core';

import Header from "../general/header";
import SidebarStations from './stationSidebar';
import Notes from './notes';
import StationDetail from './stationDetail';
import './styles.scss';

class SiteVisits extends Component {

    render() {

        let {mobile, stations, notes, zones, areas} = this.props;
        let stationSelected = stations.selectedStation > 0;
        let zoneSelected = zones.selectedZone>0;
        let areaSelected =  areas.selectedArea>0;


        if (mobile.isMobile) {

            if(notes.showNewNote){
                return (
                    <div className={'main-section site-visits-section'}>
                        <Header title={'Site Visits TM'} />
                        <StationDetail />
                    </div>
                );
            }

            if( stationSelected || zoneSelected || areaSelected) {
                return (
                    <div className={'main-section site-visits-section'}>
                        <Header title={'Site Visits TM'} />
                        <Notes  type={stationSelected? 'station': zoneSelected?'zone':'area'}/>
                    </div>
                );
            }

            return (
                <div className={'main-section site-visits-section'}>
                    <Header title={'Site Visits TM'} />
                    <SidebarStations />
                </div>
            );
        }

        return (
            <div className={'main-section site-visits-section'}>
                <Header title={'Site Visits TM'} />
                <Grid container spacing={8}>
                    <Grid item xs={2}>
                        <SidebarStations />
                    </Grid>
                    <Grid item xs={6}>
                        <Notes />
                    </Grid>
                    <Grid item xs={4}>
                        <StationDetail />
                    </Grid>
                </Grid>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        visits: state.visits,
        notes: state.notes_actions,
        zones: state.zones,
        areas: state.areas,
        stations:state.stations,
        mobile: state.mobile
    }
};

export default connect(mapStateToProps)(SiteVisits);


// WEBPACK FOOTER //
// ./src/containers/site-visits/SiteVisits.js